import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface PlanFeeStoreState {
  shouldShowFeeUpdateModal: boolean;
  setShouldShowFeeUpdateModal: (shouldShowFeeUpdateModal: boolean) => void;
}

export const usePlanFreeUpdateStore = create(
  persist<PlanFeeStoreState>(
    (set) => ({
      shouldShowFeeUpdateModal: false,
      setShouldShowFeeUpdateModal: (shouldShowFeeUpdateModal) =>
        set({ shouldShowFeeUpdateModal }),
    }),
    {
      name: 'plan-fee-update',
    },
  ),
);
